<template lang="pug">
  .list-filter
    v-layout(
      row
      wrap
    )
      v-flex(xs12)
        input-text.ml-3(
          :label="labels"
          v-model="filter"
          icon="search"
          @keyup:enter="setSearch()"
          @blur="setSearch()"
          hide-details
        )
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'ListFilter',
  components: {
    InputText,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    labels: {
      type: String,
      default: '',
    },
  },
  computed: {
    filter: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    setSearch() {
      this.$emit('search');
    },
  },
};
</script>

<style lang="stylus">
  .list-filter
    .search-field-label
      font-style normal
      font-weight normal
      font-size 14px
      line-height 56px
      color #757575
    .v-select__slot
      .v-label
        font-weight 600 !important
        color #424242
        font-size 14px
    .v-text-field > .v-input__control > .v-input__slot:before
      border-style none
    .v-text-field
      margin-top 1px
</style>
